var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudiostartRecord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.114,
    height: 30.122,
    viewBox: "0 0 30.114 30.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.005 -2.07)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_13631",
    d: "M17.063,32.192a15.057,15.057,0,1,1,10.652-4.4A15.022,15.022,0,0,1,17.063,32.192Zm0-27.711a12.655,12.655,0,1,0,8.948,3.707A12.569,12.569,0,0,0,17.063,4.48Zm9.8,22.455h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.075,21.265a1.2,1.2,0,0,1-.852-.353L8.11,15.8a1.2,1.2,0,0,1,1.7-1.7l4.261,4.261,7.879-7.879a1.2,1.2,0,1,1,1.7,1.7l-8.731,8.731A1.2,1.2,0,0,1,14.075,21.265Z",
    transform: "translate(1.18 1.652)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiostartRecord);
export default __webpack_public_path__ + "static/media/audiostartRecord.fd1ebd0859536acb9c10af1700ebaf43.svg";
export { ForwardRef as ReactComponent };